import { BookContext } from 'common/contexts/Book'
import { LandingContext } from 'common/contexts/Landing/Landing'
import { Button } from 'components/buttons'
import { baseURL } from 'models'
import { CSSProperties, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from './styled'
import { useNavigate } from 'react-router-dom'
import { MenuContext } from 'common/contexts/Menu'

type GeneralMenuProps = {
  hideOurMenu?: boolean
  hideBookTable?: boolean
  hideDelivery?: boolean
  style?: CSSProperties
}

export const GeneralMenu = ({
  hideOurMenu,
  hideBookTable,
  hideDelivery,
  ...props
}: GeneralMenuProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { setIsOpen } = useContext(BookContext)
  const { setIsOpen: menuOpen } = useContext(MenuContext)
  const { setIsOpen: setMenuOpen } = useContext(MenuContext)
  const { landing } = useContext(LandingContext)
  const lang = localStorage.getItem('Localization') ?? 'uk'

  const isBanquetVisible = landing?._id && landing?.banketEnabled
  const handleOpenMenu = () => {
    if (landing.offlineMenu === null) {
      return
    } else {
      window.open(`${baseURL}/${landing?.offlineMenu}`, '_blank')
    }
  }

  const onBookTable = () => {
    setIsOpen(true)
  }

  const handleOpenDelivery = () => {
    window.open(
      lang === 'en'
        ? 'https://restaron.ua/en/restaurant/cafe-centaur'
        : 'https://restaron.ua/restaurant/cafe-centaur',
      '_blank',
    )
  }
  const onBanquetClick = () => {
    setMenuOpen(false)
    menuOpen(false)
    navigate('/banquet')
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  return (
    <>
      <Container {...props}>
        {!hideOurMenu && (
          <Button.Text onClick={handleOpenMenu}>{t('our.menu')}</Button.Text>
        )}
        {!hideBookTable && (
          <Button.Ellipse onClick={onBookTable}>
            {t('book.table')}
          </Button.Ellipse>
        )}
        {!hideDelivery && (
          <Button.Text onClick={handleOpenDelivery}>
            {t('delivery')}
          </Button.Text>
        )}
        {isBanquetVisible && (
          <Button.Text onClick={onBanquetClick}>
            {t('banquet').toUpperCase()}
          </Button.Text>
        )}
      </Container>
    </>
  )
}
